module.exports = __webpack_public_path__ + "static/media/honeycomb.8f0948e6.webp";